import { AdvancedFilterModel, FilterModel, SortModelItem } from 'ag-grid-community';
import { signalStore } from '@ngrx/signals';
import { StorageData, StorageRef } from '../../schema/schema.interface';
import { StorageActions } from './storage.action';
import { StorageState } from './storage.state';
import { OffSubscriptionWithCatch, withSelectors, withActions } from '@res/ngg-core';

export type StorageStoreModel = StorageData & { ref: StorageRef };
export interface StorageStateModel {
  storages: StorageStoreModel[];
  isSubscribed: boolean;
  off?: OffSubscriptionWithCatch;
  isLoading: boolean;
  filter?: FilterModel | AdvancedFilterModel | null;
  sort: SortModelItem[];
}

export const StorageStore = signalStore(
  // Selectors
  { protectedState: false },
  withSelectors({
    storages: StorageState.storages,
    storageState: StorageState.storageState,
  }),
  // Actions
  withActions({
    paginateQueryStorage: StorageActions.PaginateQueryStorage,
    getAllStorages: StorageActions.GetAllStorage,
    initStorages: StorageActions.InitStorages,
    updateStorage: StorageActions.UpdateStorage,
    queryStorage: StorageActions.QueryStorage,
    addStorageItem: StorageActions.AddStorageItem,
  }),
);
